import {
  styled,
  TextField,
  IconButton,
  Paper,
  Card,
  CardActionArea,
  CardContent,
  Typography,
  Box,
  Tab,
  useMediaQuery,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import "./discover_event.css";
import { useNavigate } from "react-router-dom";
import Grid from "@mui/material/Grid2";
import SearchIcon from "@mui/icons-material/Search";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import Event1 from "../../../images/event1.jpg";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import getEventController from "../Controller/getEvent_controller.js";
import PinDropIcon from "@mui/icons-material/PinDrop";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import CategoryOutlinedIcon from "@mui/icons-material/CategoryOutlined";
import { Form } from "antd";
import SearchBar from "../../../components/SearchBox/searchbox.js";
import PPKMLogo from "../../../images/ppkmLogo.jpg";

function App2() {
  // const [api, contextHolder] = notification.useNotification();

  // const openNotificationWithIcon = (type, message) => {
  //   api[type]({
  //     message: "Success",
  //     description: message,
  //   });
  // };

  const navigate = useNavigate();
  const isLargeScreen = useMediaQuery("(min-width:640px)");

  const [form] = Form.useForm();
  const [value, setValue] = useState("1");
  // const [events, setEvents] = useState([]); // Dynamic events array
  // const [filteredEvents, setFilteredEvents] = useState(events);
  const [upcomingEvents, setUpcomingEvents] = useState([]);
  const [pastEvents, setPastEvents] = useState([]);
  const [filteredUpcomingEvents, setFilteredUpcomingEvents] = useState([]);
  const [filteredPastEvents, setFilteredPastEvents] = useState([]);

  useEffect(() => {
    // Fetch both upcoming and past events
    Promise.all([
      getEventController.getUpcomingEventRows(),
      getEventController.getPastEventRows(),
    ]).then(([upcomingResponse, pastResponse]) => {
      if (Array.isArray(upcomingResponse)) {
        setUpcomingEvents(formatEvents(upcomingResponse));
      }
      if (Array.isArray(pastResponse)) {
        setPastEvents(formatEvents(pastResponse));
        console.log(pastResponse);
      }
    });
  }, []);

  const formatEvents = (events) => {
    return events.map((item) => {
      const isValidDate = (date) =>
        date && date !== "0000-00-00" && !isNaN(new Date(date).getTime());

      const startDate = isValidDate(item.event_start_date)
        ? new Date(item.event_start_date)
        : null;
      const endDate = isValidDate(item.event_end_date)
        ? new Date(item.event_end_date)
        : null;

      const dateFormatter = new Intl.DateTimeFormat("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      });

      return {
        id: item.eventID,
        imgSrc: item.event_poster,
        title: item.event_name || "Untitled Event",
        startdate: startDate
          ? dateFormatter.format(startDate)
          : "Date not available",
        enddate: endDate ? dateFormatter.format(endDate) : "",
        venue: item.event_venue || "Venue not specified",
        category: item.event_category_name || "Untitled Category",
      };
    });
  };

  const handleSearch = (searchTerm) => {
    if (!searchTerm) {
      setFilteredUpcomingEvents(upcomingEvents);
      setFilteredPastEvents(pastEvents);
    } else {
      const lowercasedTerm = searchTerm.toLowerCase();

      setFilteredUpcomingEvents(
        upcomingEvents.filter(
          (event) =>
            event.title.toLowerCase().includes(lowercasedTerm) ||
            event.venue.toLowerCase().includes(lowercasedTerm)
        )
      );

      setFilteredPastEvents(
        pastEvents.filter(
          (event) =>
            event.title.toLowerCase().includes(lowercasedTerm) ||
            event.venue.toLowerCase().includes(lowercasedTerm)
        )
      );
    }
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  useEffect(() => {
    setFilteredUpcomingEvents(upcomingEvents);
  }, [upcomingEvents]);

  useEffect(() => {
    setFilteredPastEvents(pastEvents);
  }, [pastEvents]);

  const handleEventClick = (eventId) => {
    navigate(`/event_details/${eventId}`);
  };

  return (
    <React.Fragment>
      {!isLargeScreen ? (
        <div className="discover-event-list">
          {/*Search Bar */}
          <div className="row-1 ">
            <Grid className="sec_grid" container spacing={2}>
              <Grid size={12}>
                <TextField
                  className="searchbar"
                  label="Search"
                  variant="outlined"
                  size="small"
                  slotProps={{
                    input: {
                      endAdornment: (
                        <IconButton
                          type="button"
                          aria-label="search"
                          size="small"
                        >
                          <SearchIcon />
                        </IconButton>
                      ),
                    },
                  }}
                />
              </Grid>
            </Grid>
          </div>
          {/*Tab Divider: Upcoming*/}
          <div>
            <Box sx={{ width: "100%", typography: "body1" }}>
              <TabContext value={value}>
                {/*Upcoming Tab */}
                <TabPanel value="1">
                  <div className="event-card-row mt-2">
                    <CardActionArea
                      sx={{ maxWidth: 420 }}
                      onClick={() => navigate("/event_details")}
                    >
                      <Card
                        sx={{ maxWidth: 420, boxShadow: 5 }}
                        className="d-flex event-card"
                      >
                        <CardContent>
                          <div className="event-card-content">
                            <img src={Event1} className="event-poster" />
                            <div className="text-content">
                              <Typography sx={{ fontSize: 12, mt: 1.5 }}>
                                SHOPPING MALL MANAGEMENT CONTINUOUS EDUCATION
                                SEMINARS (SMMCES)
                              </Typography>
                              <Typography sx={{ fontSize: 10, mt: 1.5 }}>
                                9-11 August 2024, JW Marriott Kuala Lumpur
                              </Typography>
                            </div>
                            <NavigateNextIcon className="event-icon" />
                          </div>
                        </CardContent>
                      </Card>
                    </CardActionArea>
                  </div>
                </TabPanel>
              </TabContext>
            </Box>
          </div>
        </div>
      ) : (
        <div className="discover-event-list">
          <div className="discover-event-title">Discover Event(s)</div>

          {/* Search Bar */}
          <SearchBar onSearch={handleSearch} />

          <Box sx={{ width: "100%", typography: "body1" }}>
            <TabContext value={value}>
              <Box className="event-label-box">
                <TabList
                  onChange={handleChange}
                  textColor="black"
                  TabIndicatorProps={{ sx: { backgroundColor: "black" } }}
                  sx={{
                    "& .MuiTabs-flexContainer": {
                      justifyContent: "space-around", // This targets the flex container inside TabList
                    },
                  }}
                >
                  <Tab label="Current" value="1" />
                  <Tab label="Past" value="2" />
                </TabList>
              </Box>
              {/*Upcoming Tab */}
              <TabPanel value="1">
                {/* Display message if no upcoming events */}
                {filteredUpcomingEvents.length === 0 ? (
                  <div style={{ textAlign: "center", marginTop: "20px" }}>
                    <p>There're no current / upcoming events found</p>
                  </div>
                ) : (
                  <Box sx={{ width: "100%", typography: "body1" }}>
                    <Grid
                      container
                      spacing={2}
                      sx={{ justifyContent: "center", margin: "10px" }}
                    >
                      {filteredUpcomingEvents.map((event, index) => (
                        <Grid
                          item
                          xs={12}
                          sm={6}
                          md={4}
                          lg={3}
                          key={index}
                          sx={{
                            display: "flex",
                            justifyContent: "center",
                          }}
                        >
                          <Form form={form} component={false}>
                            <Paper
                              sx={(theme) => ({
                                display: "flex",
                                height: "250px",
                                width: "450px",
                                marginTop: "20px",
                                backgroundColor: "#fff",
                                ...theme.applyStyles("dark", {
                                  backgroundColor: "#1A2027",
                                }),
                                boxShadow: 5,
                                justifyContent: "flex-start",
                                borderRadius: "15px",
                                cursor: "pointer",
                                transition: "transform 0.3s ease-in-out",
                                "&:hover": {
                                  transform: "scale(1.05)",
                                  boxShadow: 10,
                                },
                              })}
                              onClick={() => handleEventClick(event.id)}
                            >
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "row",
                                  alignItems: "center",
                                  padding: "10px",
                                }}
                                id={event.id}
                              >
                                {/* Poster Image */}
                                <img
                                  src={
                                    event.imgSrc && event.imgSrc.trim() !== ""
                                      ? event.imgSrc
                                      : PPKMLogo
                                  }
                                  alt={event.title}
                                  className="upcoming-event-poster"
                                />

                                {/* Event Info */}
                                <div
                                  style={{
                                    display: "flex",
                                    flexDirection: "column",
                                  }}
                                >
                                  {/* Title next to the image */}
                                  <span className="event-title">
                                    {event.title}
                                  </span>

                                  {/* Date and Venue below the title */}
                                  <div className="event-date-venue">
                                    <span
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        marginTop: "5px",
                                      }}
                                    >
                                      <CalendarMonthIcon className="de-icon" />
                                      {event.startdate} - {event.enddate}
                                    </span>
                                    <span
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                      }}
                                    >
                                      <PinDropIcon className="de-icon" />
                                      {event.venue}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </Paper>
                          </Form>
                        </Grid>
                      ))}
                    </Grid>
                  </Box>
                )}
              </TabPanel>
              {/*Past Tab */}
              <TabPanel value="2">
                {/* Display message if no upcoming events */}
                {filteredPastEvents.length === 0 ? (
                  <div style={{ textAlign: "center", marginTop: "20px" }}>
                    <p>There're no past event(s) found</p>
                  </div>
                ) : (
                  <Box sx={{ width: "100%", typography: "body1" }}>
                    <Grid
                      container
                      spacing={2}
                      sx={{ justifyContent: "center", margin: "10px" }}
                    >
                      {filteredPastEvents.map((event, index) => (
                        <Grid
                          item
                          xs={12}
                          sm={6}
                          md={4}
                          lg={3}
                          key={index}
                          sx={{
                            display: "flex",
                            justifyContent: "center",
                          }}
                        >
                          <Form form={form} component={false}>
                            <Paper
                              sx={(theme) => ({
                                display: "flex",
                                height: "250px",
                                width: "450px",
                                marginTop: "20px",
                                backgroundColor: "#fff",
                                ...theme.applyStyles("dark", {
                                  backgroundColor: "#1A2027",
                                }),
                                boxShadow: 5,
                                justifyContent: "flex-start",
                                borderRadius: "15px",
                                cursor: "pointer",
                                transition: "transform 0.3s ease-in-out",
                                "&:hover": {
                                  transform: "scale(1.05)",
                                  boxShadow: 10,
                                },
                              })}
                              onClick={() => handleEventClick(event.id)}
                            >
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "row",
                                  alignItems: "center",
                                  padding: "10px",
                                }}
                                id={event.id}
                              >
                                {/* Poster Image */}
                                <img
                                  src={
                                    event.imgSrc && event.imgSrc.trim() !== ""
                                      ? event.imgSrc
                                      : PPKMLogo
                                  }
                                  alt={event.title}
                                  className="upcoming-event-poster"
                                />

                                {/* Event Info */}
                                <div
                                  style={{
                                    display: "flex",
                                    flexDirection: "column",
                                  }}
                                >
                                  {/* Title next to the image */}
                                  <span className="event-title">
                                    {event.title}
                                  </span>

                                  {/* Date and Venue below the title */}
                                  <div className="event-date-venue">
                                    <span
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        marginTop: "5px",
                                      }}
                                    >
                                      <CalendarMonthIcon className="de-icon" />
                                      {event.enddate === ""
                                        ? event.startdate
                                        : `${event.startdate} - ${event.enddate}`}
                                    </span>
                                    <span
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                      }}
                                    >
                                      <PinDropIcon className="de-icon" />
                                      {event.venue}
                                    </span>
                                    {/* <span
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                      }}
                                    >
                                      <CategoryOutlinedIcon className="de-icon" />
                                      {event.category}
                                    </span> */}
                                  </div>
                                </div>
                              </div>
                            </Paper>
                          </Form>
                        </Grid>
                      ))}
                    </Grid>
                  </Box>
                )}
              </TabPanel>
            </TabContext>
          </Box>
          {/* // )} */}
        </div>
      )}
    </React.Fragment>
  );
}

export default App2;
